import React from 'react';
import Button from '@/components/atoms/Button';
import Icon from '@/components/atoms/Icon/Icon';
import './CalendarHeader.scss';

interface CalendarHeaderProps {
  title: string;
  onBack: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ title, onBack }) => {
  return (
    <div className="events-calendar-page__header">
      <Button
        variant="ghost"
        size="sm"
        onClick={onBack}
        className="events-calendar-page__back"
      >
        <Icon name="atras" size={20} />
      </Button>
      <h1 className="events-calendar-page__title">{title}</h1>
    </div>
  );
};

export default CalendarHeader;
